<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead.text-center
          tr
            th(style="width: 80px;" rowspan="2")
              div {{ $t('ui.time') }}
            th(style="width: 450px;" rowspan="2")
              div {{ $t('ui.event') }}
            th
              div {{ $t('ui.first_goal') }}
            th
              div {{ $t('ui.last_goal') }}
            th
              div {{ $t('ui.no_goal') }}
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.ffgh_blink }") {{ item.ffgh }}
              div(:class="{'up': item.ffga_blink }") {{ item.ffga }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.flgh_blink }") {{ item.flgh }}
              div(:class="{'up': item.flga_blink }") {{ item.flga }}
            td(style="vertical-align:middle;width: 100px;").text-center
              div(:class="{'up': item.fng_blink }") {{ item.fng }}
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>
